import React from 'react'

const Home = () => {
    return (
        <>
            <img src='image (2).png' alt="baground image" className='bagrounimage'></img>
            <div className='container'>
                <h1 className='text-center mt-3 mb-3' style={{ color: '#162f94' }}>WHAT WE DO</h1>
                <div className='row'>
                    <div className='col-md-4 col-sm-12'>
                        <div className='card mt-3 mb-2 text-center'>
                            <img src='pexels-designecologist-1779487.png' alt='image'></img>
                            <h3 className='mt-3 mb-2'>IT made interesting</h3>
                            <p>
                                Arhsys combines its experience in technology and the power of deriving complex solutions with a team of highly skilled IT professionals, telling the story of our expertise.
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-12'>
                        <div className='card mt-3 mb-2 text-center'>
                            <img src='cr=w_730,h_730.webp' alt='image'></img>
                            <h3 className='mt-3 mb-2'>Staffing Redefined</h3>
                            <p>
                                Our staff selection process focuses on screening candidates to bring in thought-provoking and energetic individuals who strive to excel in challenging and unconventional scenarios.
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-12'>
                        <div className='card mt-3 mb-2 text-center'>
                            <img src='cr=w_730,h_730 (1).webp' alt='image'></img>
                            <h3 className='mt-3 mb-2'>Why Arhsys</h3>
                            <p>
                                The success of a relationship is built on trust with the client, open dialogue, seamless delivery, and value-driven operations. Arhsys LLC strives to ensure that our team always aligns with the client's goals, ensuring mutual success.
                                .</p>
                        </div>
                    </div>
                </div>
                <h1 className='text-center mt-3 mb-3' style={{ color: '#162f94' }}>INDUSTRY LEADING SKILL SETS</h1>
                <div className='container mb-5'>
                    <div className='row'>
                        <div className='col-md-4 col-sm-12'>
                            <div className='card mt-3 mb-2'>
                                <img src='cr=w_776,h_388.webp' alt='image'></img>
                                <h3 className='text-center'>Cloud and AI</h3>
                                <p></p>
                                <ul>
                                    <li>AWS</li>
                                    <li>Microsoft Azure</li>
                                    <li>Heroku</li>
                                    <li>Artificial Intelligence</li>
                                    <li>Machine Learning</li>
                                    <li>Automation( Application Automation and Robotic process automation)</li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-md-4 col-sm-12'>
                            <div className='card mt-3 mb-2'>
                                <img src='Technology.webp' alt='image'></img>
                                <h3 className='text-center'>Technology stack</h3>
                                <ul>
                                    <li>ReactJS</li>
                                    <li>AngularJS</li>
                                    <li>React</li>
                                    <li>jQuery</li>
                                    <li>Nginx</li>
                                    <li>Django</li>
                                    <li>Apache</li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-md-4 col-sm-12'>
                            <div className='card mt-3 mb-2'>
                                <img src='ItLanguage.webp' alt='image'></img>
                                <h3 className='text-center'>IT Languages</h3>
                                <li>python</li>
                                <li>java</li>
                                <li>.net</li>
                                <li>c++</li>
                                <li>Ruby</li>
                                <li>Blockly </li>
                                <li>HTML/HTML5</li>
                                <li>Objective-C</li>
                            </div>
                        </div>
                        <div className='col-md-4 col-sm-12'>
                            <div className='card mt-3 mb-2'>
                                <img src='managementSkills.webp' alt='image'></img>
                                <h3 className='text-center'>Management Skills</h3>
                                <ul>
                                    <li>Project Management</li>
                                    <li>Agile</li>
                                    <li>Business Analyst</li>
                                    <li>Systems Analyst</li>
                                    <li>Quality Assurance</li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-md-4 col-sm-12'>
                            <div className='card mt-3 mb-2'>
                                <img src='method.webp' alt='image'></img>
                                <h3 className='text-center'>Methodologies</h3>
                                <ul>
                                    <li>Agile</li>
                                    <li>DevOps</li>
                                    <li>Kanban</li>
                                    <li>Lean Six Sigma</li>
                                    <li>IT Infrastructure Library</li>
                                    <li>Scrum</li>
                                    <li>Waterfall</li>

                                </ul>
                            </div>
                        </div>
                        <div className='col-md-4 col-sm-12'>
                            <div className='card mt-3 mb-2'>
                                <img src='database.webp' alt='image'></img>
                                <h3 className='text-center'>Databases</h3>
                                <ul>
                                    <li>Microsoft SQL Server </li>
                                    <li>MySQL</li>
                                    <li>PostgreSQL</li>
                                    <li>Oracle</li>
                                    <li>Neo4j </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Home